import { LoginFormValues } from '../types';

export const initialValues: LoginFormValues = { email: '', password: '', remember: true };
